export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-voronoi/src/constant.js
// module id = A/Uw
// module chunks = 0